import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { API_URL } from "../../../../api";
import axios from "axios";

const PurchasePromotionForm = () => {
  const token = localStorage.getItem("token");
    const url = API_URL();
    const api = axios.create({
      baseURL: url,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });
  const navigate = useNavigate();
  const { id } = useParams();
  const isEdit = Boolean(id);

  const [pageLoading, setPageLoading] = useState(false);
  const [items, setItems] = useState([]);

  
  const RELATED_SHOP_ID = "6a3cb811d3a1481217ee9f92";

  const [formData, setFormData] = useState({
    name: "",
    description: "",
    startDate: "",
    endDate: "",

    earnType: "VoucherAmount",
    earnValue: "",

    totalStampsRequired: "",

    rewardValue: "",

    focItemModel: "Treatments",
    focItem: "",

    relatedShop: RELATED_SHOP_ID,
  });

  useEffect(() => {
    if (!id) return;
    const fetchPromotion = async () => {
      setPageLoading(true);
      try {
        const res = await api.get("stamp-programs/" + id);
        const data = res.data?.data || res.data;
        setFormData({
          name: data.name || "",
          description: data.description || "",
          startDate: data.startDate ? data.startDate.slice(0, 10) : "",
          endDate: data.endDate ? data.endDate.slice(0, 10) : "",
          earnType: data.earnType || "VoucherAmount",
          earnValue: data.earnValue ?? "",
          totalStampsRequired: data.totalStampsRequired ?? "",
          rewardValue: data.rewardValue ?? "",
          focItemModel: data.focItemModel || "Treatments",
          focItem: data.focItem || "",
          relatedShop: data.relatedShop || RELATED_SHOP_ID,
        });
        setRewardType(
          data.rewardType === "Amount" ? "amount"
          : data.rewardType === "Percentage" ? "percent"
          : "foc"
        );
      } catch (err) {
        setError(err.message);
      } finally {
        setPageLoading(false);
      }
    };
    fetchPromotion();
  }, [id]);

  useEffect(() => {
    setItems([]);
    const controller = new AbortController();
    const fetchItems = async () => {
      try {
        const endpoint =
          formData.focItemModel === "Treatments" ? "treatments" : "medicine-items";
        const res = await api.get(endpoint, { signal: controller.signal });
        setItems(res.data.list);
        setFormData((prev) => ({ ...prev, focItem: "" }));
      } catch (err) {
        if (err.name !== "CanceledError") console.error(err);
      }
    };
    if (formData.focItemModel) fetchItems();
    return () => controller.abort();
  }, [formData.focItemModel]);

  const [promotionType, setPromotionType] = useState("stamp");
  const [rewardType, setRewardType] = useState("amount");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(false);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;

    setFormData({
      ...formData,
      [name]: type === "checkbox" ? checked : value,
    });

    if (name === "focItemModel") {
      setItems([]);
    }
  };

  const handleSubmit = async () => {
    setLoading(true);
    setError(null);
    setSuccess(false);

    try {
      const payload = {
  name: formData.name,
  description: formData.description,
  startDate: formData.startDate,
  endDate: formData.endDate,

  earnType: formData.earnType,
  earnValue: Number(formData.earnValue),

  totalStampsRequired: Number(formData.totalStampsRequired),

  rewardType:
    rewardType === "amount"
      ? "Amount"
      : rewardType === "percent"
      ? "Percentage"
      : "FOCItem",

  rewardValue:
    rewardType !== "foc"
      ? Number(formData.rewardValue)
      : undefined,

  relatedShop: RELATED_SHOP_ID,
};

if (rewardType === "foc") {
  payload.focItemModel = formData.focItemModel;
  payload.focItem = formData.focItem;
}

      if (id) {
        await api.patch("stamp-programs/" + id, payload);
      } else {
        await api.post("stamp-programs", payload);
      }

      setFormData({
        name: "",
        description: "",
        startDate: "",
        endDate: "",
        earnType: "VoucherAmount",
        earnValue: "",
        totalStampsRequired: "",
        rewardValue: "",
        focItemModel: "Treatments",
        focItem: "",
        relatedShop: RELATED_SHOP_ID,
      });
      setPromotionType("stamp");
      setRewardType("amount");
      setSuccess(true);

      navigate("/purchase-discount-rules");
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="container-fluid py-4">

      <div className="d-flex justify-content-between align-items-center mb-4">
        <div>
          <h3 className="mb-1">{isEdit ? "Edit" : "Create"} Purchase Promotion</h3>
          <small className="text-muted">
            Configure purchase promotion rules
          </small>
        </div>
      </div>

      <div className="card shadow-sm mb-4">
        <div className="card-header bg-white">
          <h5 className="mb-0">Basic Information</h5>
        </div>
        <div className="card-body">
          <div className="row">
            <div className="col-md-12 mb-3">
              <label className="form-label">
                Promotion Name
              </label>

              <input
                className="form-control"
                name="name"
                value={formData.name}
                onChange={handleChange}
              />
            </div>
            <div className="col-md-6 mb-3">
              <label className="form-label">
                Start Date
              </label>
              <input
                type="date"
                className="form-control"
                name="startDate"
                value={formData.startDate}
                onChange={handleChange}
              />
            </div>
            <div className="col-md-6 mb-3">
              <label className="form-label">
                End Date
              </label>
              <input
                type="date"
                className="form-control"
                name="endDate"
                value={formData.endDate}
                onChange={handleChange}
              />
            </div>
            <div className="col-12 mb-3">
              <label className="form-label">
                Description
              </label>
              <textarea
                rows="3"
                className="form-control"
                name="description"
                value={formData.description}
                onChange={handleChange}
              />
            </div>
            {/* <div className="col-md-6 mb-3">
              <label className="form-label">
                Status
              </label>
              <div className="form-check mt-3">
                <input
                  type="checkbox"
                  className="form-check-input"
                  checked={formData.status}
                  name="status"
                  onChange={handleChange}
                />
                <label className="form-check-label">
                  Active
                </label>
              </div>
            </div>
            <div className="col-md-6 mb-3">
              <label className="form-label">
                Promotion Type
              </label>
              <div className="d-flex gap-4 mt-3">
                <div className="form-check">
                  <input
                    className="form-check-input"
                    type="radio"
                    checked={promotionType === "whole"}
                    onChange={() => setPromotionType("whole")}
                  />
                  <label className="form-check-label">
                    Whole Amount Promotion
                  </label>
                </div>
                <div className="form-check">
                  <input
                    className="form-check-input"
                    type="radio"
                    checked={promotionType === "stamp"}
                    onChange={() => setPromotionType("stamp")}
                  />
                  <label className="form-check-label">
                    Stamp Based Promotion
                  </label>
                </div>
              </div>
            </div> */}
          </div>
          <hr class="border-top border-secondary opacity-25"></hr>
          {/* {promotionType === "whole" && (
            <div className="mb-4 mt-3">
              <div className="bg-white">
                <h5 className="mb-0">
                  Whole Amount Rule
                </h5>
              </div>
              <div className="mt-4">
                <div className="row">
                  <div className="col-md-6 mb-3">
                    <label className="form-label">
                      Reward Based On
                    </label>
                    <select
                      className="form-select"
                      name="triggerType"
                      value={formData.triggerType}
                      onChange={handleChange}
                    >
                      <option value="treatmentTime">
                        Treatment Time
                      </option>
                      <option value="voucherTimes">
                        Voucher Times
                      </option>
                      <option value="voucherAmount">
                        Voucher Amount
                      </option>
                    </select>
                  </div>
                  <div className="col-md-6 mb-3">
                    <label className="form-label">
                      Minimum Value
                    </label>
                    <input
                      className="form-control"
                      name="conditionValue"
                      value={formData.conditionValue}
                      onChange={handleChange}
                    />
                  </div>
                </div>
              </div>
            </div>
          )} */}
          {promotionType === "stamp" && (
              <div className="mb-4">
                  <div>
                      <h5 className="mb-0">
                          Stamp Rule
                      </h5>
                  </div>
                  <div className="mt-4">
                      <div className="row">
                          <div className="col-md-6 mb-3">
                              <label className="form-label">
                                  One Stamp Based On
                              </label>
                              <select
                                className="form-select"
                                name="earnType"
                                value={formData.earnType}
                                onChange={handleChange}
                            >
                                <option value="TreatmentTime">Treatment Time</option>
                                <option value="VoucherTimes">Voucher Times</option>
                                <option value="VoucherAmount">Voucher Amount</option>
                            </select>

                          </div>
                          <div className="col-md-6 mb-3">
                              <label className="form-label">
                                  Earn Value (Per time)
                              </label>
                              <input
                                  className="form-control"
                                  name="earnValue"
                                  value={formData.earnValue}
                                  onWheel={(e) => e.target.blur()}
                                  onChange={handleChange}
                              />
                          </div>
                          <div className="col-md-6">
                              <label className="form-label">
                                  Required Number of Stamps
                              </label>
                              <input
                                  type="number"
                                  className="form-control"
                                  name="totalStampsRequired"
                                  value={formData.totalStampsRequired}
                                  onChange={handleChange}
                                  onWheel={(e) => e.target.blur()}
                              />
                          </div>
                      </div>
                  </div>
              </div>
          )}
        </div>
      </div>
      <div className="card shadow-sm mb-4">
        <div className="card-header bg-white">
            <h5 className="mb-0">
                Reward
            </h5>
        </div>
        <div className="card-body">
            <div className="mb-4">
                <label className="form-label fw-bold">
                    Reward Type
                </label>
                <div className="d-flex gap-3 mt-2">
                    <div className="form-check">
                        <input
                            className="form-check-input"
                            type="radio"
                            checked={rewardType === "amount"}
                            onChange={() => setRewardType("amount")}
                        />
                        <label className="form-check-label">
                            Discount Amount
                        </label>
                    </div>
                    <div className="form-check">
                        <input
                            className="form-check-input"
                            type="radio"
                            checked={rewardType === "percent"}
                            onChange={() => setRewardType("percent")}
                        />
                        <label className="form-check-label">
                            Discount Percentage
                        </label>
                    </div>
                    <div className="form-check">
                        <input
                            className="form-check-input"
                            type="radio"
                            checked={rewardType === "foc"}
                            onChange={() => setRewardType("foc")}
                        />
                        <label className="form-check-label">
                            Free Of Charge (FOC)
                        </label>
                    </div>
                </div>
            </div>
        </div>
        {rewardType === "amount" && (
            <div className="row">
                <div className="col-md-6">
                    <label className="form-label">
                        Discount Amount
                    </label>
                    <input
                        className="form-control"
                        name="rewardValue"
                        value={formData.rewardValue}
                        onWheel={(e) => e.target.blur()}
                        onChange={handleChange}
                    />
                </div>
            </div>
        )}
        {rewardType === "percent" && (
            <div className="row">
                <div className="col-md-6">
                    <label className="form-label">
                        Discount Percentage
                    </label>
                    <input
                        className="form-control"
                        name="rewardValue"
                        value={formData.rewardValue}
                        onWheel={(e) => e.target.blur()}
                        onChange={handleChange}
                    />
                </div>
            </div>
        )}
        {rewardType === "foc" && (
            <div className="row">
                <div className="col-md-4 mb-3">
                    <label className="form-label">
                        Reward Type
                    </label>
                    <select
                        className="form-select"
                        name="focItemModel"
                        value={formData.focItemModel}
                        onChange={handleChange}
                    >
                        <option value="Treatments">Treatment</option>
                        <option value="MedicineItems">Medicine</option>
                    </select>
                </div>
                <div className="col-md-5 mb-3">
                    <label className="form-label">
                        Reward Item
                    </label>
                    <select
                        className="form-select"
                        name="focItem"
                        value={formData.focItem}
                        onChange={handleChange}
                    >
                        <option value="">
                            Select Item
                        </option>
                        {items.map((item) => (
                            <option key={item._id} value={item._id}>
                                {formData.focItemModel === "Treatments"
                                    ? (typeof item.name === "string" ? item.name : typeof item.treatmentName?.name === "string" ? item.treatmentName.name : item._id)
                                    : (typeof item.medicineItemName === "string" ? item.medicineItemName : item._id)}
                            </option>
                        ))}
                    </select>
                </div>
                <div className="col-md-3">
                    <label className="form-label">
                        Quantity
                    </label>
                    <input
                        type="number"
                        className="form-control"
                        name="focQty"
                        value={formData.focQty}
                        onWheel={(e) => e.target.blur()}
                        onChange={handleChange}
                    />
                </div>
            </div>
        )}
    </div>
    <div className="d-flex justify-content-end gap-2">
      <button className="btn btn-secondary me-2">
         Cancel
      </button>
      <button className="btn btn-primary" onClick={handleSubmit} disabled={loading}>
        {loading ? "Saving..." : isEdit ? "Update Promotion" : "Save Promotion"}
      </button>

      {error && (
        <div className="alert alert-danger">
          {error}
        </div>
      )}

      {success && (
        <div className="alert alert-success">
          Promotion saved successfully!
        </div>
      )}
    </div>
</div>
  );
};

export default PurchasePromotionForm;